import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import PageModalTitle from 'Views/Page/Content/Modal/Components/PageModalTitle';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
  fields: {
    padding: theme.spacing(0),
    width: '100%',
  },
});

const FacetPlanVirtualAccountFundingInstructionsFundingTypeStep = ({
  className,
  classes,
}) => {
  const { saving, resource, onSubmit } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <PageModalTitle>
        <Title text="Funding Instructions" />
      </PageModalTitle>
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanVirtualAccountFundingInstructionsFundingTypeStep.defaultProps = {
  className: '',
};

FacetPlanVirtualAccountFundingInstructionsFundingTypeStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanVirtualAccountFundingInstructionsFundingTypeStep);
